// Mock Data for AD Ventures CRM Dashboard

export const ROLES = {
  admin: 'admin',
  supreme_manager: 'supreme_manager',
  manager: 'manager',
  quality_checker: 'quality_checker',
  field_executive: 'field_executive',
  vendor: 'vendor',
  client: 'client',
  business_partner: 'business_partner',
  universal_qc: 'universal_qc',
  data_entry_operator: 'data_entry_operator',
  ADMIN: 'admin',
  SUPREME_MANAGER: 'supreme_manager',
  MANAGER: 'manager',
  QUALITY_CHECKER: 'quality_checker',
  FIELD_EXECUTIVE: 'field_executive',
  VENDOR: 'vendor',
  CLIENT: 'client',
  BUSINESS_PARTNER: 'business_partner',
  UNIVERSAL_QC: 'universal_qc',
  DATA_ENTRY_OPERATOR: 'data_entry_operator',
};

export const ROLE_LABELS = {
  admin: 'Admin',
  supreme_manager: 'Supreme Manager',
  manager: 'Manager',
  quality_checker: 'Quality Checker',
  field_executive: 'Field Executive',
  vendor: 'Vendor',
  client: 'Client',
  business_partner: 'Business Partner',
  universal_qc: 'Universal QC',
  data_entry_operator: 'Data Entry Operator',
};

export const mockUsers = [
  { id: 'USR001', name: 'Rajesh Kumar', email: 'rajesh.kumar@adventures.com', role: 'admin', status: 'active', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100', phone: '+91 98765 43210', joinDate: '2023-01-15' },
  { id: 'USR002', name: 'Priya Sharma', email: 'priya.sharma@adventures.com', role: 'supreme_manager', status: 'active', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100', phone: '+91 98765 43211', joinDate: '2023-02-20' },
  { id: 'USR003', name: 'Amit Patel', email: 'amit.patel@adventures.com', role: 'manager', status: 'active', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100', phone: '+91 98765 43212', joinDate: '2023-03-10' },
  { id: 'USR004', name: 'Sneha Reddy', email: 'sneha.reddy@adventures.com', role: 'quality_checker', status: 'active', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100', phone: '+91 98765 43213', joinDate: '2023-04-05' },
  { id: 'USR005', name: 'Vikram Singh', email: 'vikram.singh@adventures.com', role: 'field_executive', status: 'active', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100', phone: '+91 98765 43214', joinDate: '2023-05-12' },
  { id: 'USR006', name: 'Ananya Gupta', email: 'ananya.gupta@adventures.com', role: 'field_executive', status: 'inactive', avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100', phone: '+91 98765 43215', joinDate: '2023-06-18' },
  { id: 'USR007', name: 'Karan Mehta', email: 'karan.mehta@vendor.com', role: 'vendor', status: 'active', avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100', phone: '+91 98765 43216', joinDate: '2023-07-22' },
  { id: 'USR008', name: 'Neha Joshi', email: 'neha.joshi@client.com', role: 'client', status: 'active', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100', phone: '+91 98765 43217', joinDate: '2023-08-30' },
  { id: 'USR009', name: 'Rohit Verma', email: 'rohit.verma@partner.com', role: 'business_partner', status: 'active', avatar: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100', phone: '+91 98765 43218', joinDate: '2023-09-14' },
  { id: 'USR010', name: 'Deepa Nair', email: 'deepa.nair@adventures.com', role: 'universal_qc', status: 'active', avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100', phone: '+91 98765 43219', joinDate: '2023-10-08' },
  { id: 'USR011', name: 'Sanjay Tiwari', email: 'sanjay.tiwari@adventures.com', role: 'data_entry_operator', status: 'active', avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=100', phone: '+91 98765 43220', joinDate: '2023-11-01' },
];

export const mockClients = [
  { id: 'CLT001', name: 'HDFC Bank', contactPerson: 'Suresh Iyer', email: 'suresh@hdfc.com', phone: '+91 22 6160 6161', status: 'active', totalCases: 1250, products: ['Address Verification', 'Employment Verification'], logo: 'https://logo.clearbit.com/hdfcbank.com' },
  { id: 'CLT002', name: 'ICICI Bank', contactPerson: 'Meera Krishnan', email: 'meera@icici.com', phone: '+91 22 3366 3366', status: 'active', totalCases: 980, products: ['KYC Verification', 'Document Verification'], logo: 'https://logo.clearbit.com/icicibank.com' },
  { id: 'CLT003', name: 'Bajaj Finance', contactPerson: 'Rahul Bajaj', email: 'rahul@bajaj.com', phone: '+91 20 7157 6857', status: 'active', totalCases: 756, products: ['Address Verification', 'Income Verification'], logo: 'https://logo.clearbit.com/bajajfinserv.in' },
  { id: 'CLT004', name: 'Axis Bank', contactPerson: 'Priya Nair', email: 'priya@axis.com', phone: '+91 22 6797 6797', status: 'inactive', totalCases: 432, products: ['Employment Verification'], logo: 'https://logo.clearbit.com/axisbank.com' },
  { id: 'CLT005', name: 'Kotak Mahindra', contactPerson: 'Arun Kotak', email: 'arun@kotak.com', phone: '+91 22 6166 6166', status: 'active', totalCases: 654, products: ['Address Verification', 'Business Verification'], logo: 'https://logo.clearbit.com/kotak.com' },
];

export const mockProducts = [
  { id: 'PRD001', name: 'Address Verification', code: 'AV', description: 'Physical address verification at given location', basePrice: 250, status: 'active' },
  { id: 'PRD002', name: 'Employment Verification', code: 'EV', description: 'Verification of employment details and income', basePrice: 350, status: 'active' },
  { id: 'PRD003', name: 'KYC Verification', code: 'KYC', description: 'Know Your Customer verification process', basePrice: 200, status: 'active' },
  { id: 'PRD004', name: 'Document Verification', code: 'DV', description: 'Verification of submitted documents', basePrice: 150, status: 'active' },
  { id: 'PRD005', name: 'Income Verification', code: 'IV', description: 'Verification of income sources and salary', basePrice: 400, status: 'active' },
  { id: 'PRD006', name: 'Business Verification', code: 'BV', description: 'Business existence and legitimacy verification', basePrice: 500, status: 'active' },
  { id: 'PRD007', name: 'Reference Check', code: 'RC', description: 'Personal and professional reference verification', basePrice: 180, status: 'inactive' },
];

export const CASE_STATUSES = {
  CREATED: 'created',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  VERIFIED: 'verified',
  QC_PENDING: 'qc_pending',
  QC_APPROVED: 'qc_approved',
  QC_REJECTED: 'qc_rejected',
  REVISIT: 'revisit',
  COMPLETED: 'completed',
  REPORT_SENT: 'report_sent',
  DELETE_REQUESTED: 'delete_requested',
  DELETE_APPROVED: 'delete_approved',
  DELETE_REJECTED: 'delete_rejected',
};

export const STATUS_CONFIG = {
  [CASE_STATUSES.CREATED]: { label: 'Created', color: 'neutral', step: 1 },
  [CASE_STATUSES.ASSIGNED]: { label: 'Assigned', color: 'info', step: 2 },
  [CASE_STATUSES.IN_PROGRESS]: { label: 'In Progress', color: 'warning', step: 3 },
  [CASE_STATUSES.VERIFIED]: { label: 'Verified', color: 'info', step: 4 },
  [CASE_STATUSES.QC_PENDING]: { label: 'QC Pending', color: 'warning', step: 5 },
  [CASE_STATUSES.QC_APPROVED]: { label: 'QC Approved', color: 'success', step: 6 },
  [CASE_STATUSES.QC_REJECTED]: { label: 'QC Rejected', color: 'danger', step: 5 },
  [CASE_STATUSES.REVISIT]: { label: 'Revisit Required', color: 'danger', step: 3 },
  [CASE_STATUSES.COMPLETED]: { label: 'Completed', color: 'success', step: 7 },
  [CASE_STATUSES.REPORT_SENT]: { label: 'Report Sent', color: 'success', step: 8 },
  [CASE_STATUSES.DELETE_REQUESTED]: { label: 'Deletion Pending', color: 'warning', step: 5 },
  [CASE_STATUSES.DELETE_APPROVED]: { label: 'Deleted', color: 'danger', step: 9 },
  [CASE_STATUSES.DELETE_REJECTED]: { label: 'Delete Rejected', color: 'neutral', step: 5 },
};

export const mockCases = [
  {
    id: 'CASE001',
    refNumber: 'ADV-2024-00001',
    client: mockClients[0],
    product: mockProducts[0],
    applicantName: 'Anil Sharma',
    applicantPhone: '+91 99887 76655',
    applicantEmail: 'anil.sharma@email.com',
    address: '123, Sector 15, Noida, UP 201301',
    status: CASE_STATUSES.IN_PROGRESS,
    priority: 'high',
    assignedTo: mockUsers[4],
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-16T14:20:00Z',
    dueDate: '2024-01-18T18:00:00Z',
    documents: [
      { name: 'Aadhaar Card.pdf', size: '256 KB', type: 'pdf' },
      { name: 'PAN Card.jpg', size: '128 KB', type: 'image' },
    ],
    images: [],
    qcLogs: [],
    timeline: [
      { action: 'Case Created', user: mockUsers[0], timestamp: '2024-01-15T10:30:00Z' },
      { action: 'Assigned to Vikram Singh', user: mockUsers[2], timestamp: '2024-01-15T11:00:00Z' },
      { action: 'Verification Started', user: mockUsers[4], timestamp: '2024-01-16T09:00:00Z' },
    ],
  },
  {
    id: 'CASE002',
    refNumber: 'ADV-2024-00002',
    client: mockClients[1],
    product: mockProducts[1],
    applicantName: 'Sunita Devi',
    applicantPhone: '+91 88776 65544',
    applicantEmail: 'sunita.devi@email.com',
    address: '456, MG Road, Bangalore, KA 560001',
    status: CASE_STATUSES.QC_PENDING,
    priority: 'medium',
    assignedTo: mockUsers[5],
    createdAt: '2024-01-14T09:15:00Z',
    updatedAt: '2024-01-16T16:45:00Z',
    dueDate: '2024-01-17T18:00:00Z',
    documents: [
      { name: 'Salary Slip.pdf', size: '512 KB', type: 'pdf' },
    ],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE003',
    refNumber: 'ADV-2024-00003',
    client: mockClients[2],
    product: mockProducts[2],
    applicantName: 'Mohammed Khan',
    applicantPhone: '+91 77665 54433',
    applicantEmail: 'mohammed.khan@email.com',
    address: '789, Linking Road, Mumbai, MH 400050',
    status: CASE_STATUSES.COMPLETED,
    priority: 'low',
    assignedTo: mockUsers[4],
    createdAt: '2024-01-10T14:00:00Z',
    updatedAt: '2024-01-15T12:00:00Z',
    dueDate: '2024-01-14T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [
      { action: 'Approved', comment: 'All documents verified correctly', user: mockUsers[3], timestamp: '2024-01-15T11:00:00Z' },
    ],
    timeline: [],
  },
  {
    id: 'CASE004',
    refNumber: 'ADV-2024-00004',
    client: mockClients[0],
    product: mockProducts[3],
    applicantName: 'Rekha Gupta',
    applicantPhone: '+91 66554 43322',
    applicantEmail: 'rekha.gupta@email.com',
    address: '321, Connaught Place, Delhi 110001',
    status: CASE_STATUSES.QC_REJECTED,
    priority: 'high',
    assignedTo: mockUsers[4],
    createdAt: '2024-01-12T08:30:00Z',
    updatedAt: '2024-01-16T10:00:00Z',
    dueDate: '2024-01-15T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [
      { action: 'Rejected', comment: 'Address mismatch found', user: mockUsers[3], timestamp: '2024-01-16T10:00:00Z' },
    ],
    timeline: [],
  },
  {
    id: 'CASE005',
    refNumber: 'ADV-2024-00005',
    client: mockClients[3],
    product: mockProducts[4],
    applicantName: 'Vijay Malhotra',
    applicantPhone: '+91 55443 32211',
    applicantEmail: 'vijay.malhotra@email.com',
    address: '567, Park Street, Kolkata, WB 700016',
    status: CASE_STATUSES.ASSIGNED,
    priority: 'medium',
    assignedTo: mockUsers[5],
    createdAt: '2024-01-16T07:00:00Z',
    updatedAt: '2024-01-16T08:30:00Z',
    dueDate: '2024-01-19T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE006',
    refNumber: 'ADV-2024-00006',
    client: mockClients[4],
    product: mockProducts[5],
    applicantName: 'Lakshmi Menon',
    applicantPhone: '+91 44332 21100',
    applicantEmail: 'lakshmi.menon@email.com',
    address: '890, Anna Salai, Chennai, TN 600002',
    status: CASE_STATUSES.CREATED,
    priority: 'low',
    assignedTo: null,
    createdAt: '2024-01-16T11:00:00Z',
    updatedAt: '2024-01-16T11:00:00Z',
    dueDate: '2024-01-20T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE007',
    refNumber: 'ADV-2024-00007',
    client: mockClients[1],
    product: mockProducts[0],
    applicantName: 'Ramesh Yadav',
    applicantPhone: '+91 33221 10099',
    applicantEmail: 'ramesh.yadav@email.com',
    address: '234, Shivaji Nagar, Pune, MH 411005',
    status: CASE_STATUSES.REVISIT,
    priority: 'high',
    assignedTo: mockUsers[4],
    createdAt: '2024-01-08T13:00:00Z',
    updatedAt: '2024-01-16T09:30:00Z',
    dueDate: '2024-01-17T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [
      { action: 'Revisit Requested', comment: 'Incomplete verification, need more photos', user: mockUsers[3], timestamp: '2024-01-16T09:30:00Z' },
    ],
    timeline: [],
  },
  {
    id: 'CASE008',
    refNumber: 'ADV-2024-00008',
    client: mockClients[2],
    product: mockProducts[1],
    applicantName: 'Pooja Saxena',
    applicantPhone: '+91 22110 09988',
    applicantEmail: 'pooja.saxena@email.com',
    address: '678, Civil Lines, Jaipur, RJ 302006',
    status: CASE_STATUSES.REPORT_SENT,
    priority: 'medium',
    assignedTo: mockUsers[5],
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-14T16:00:00Z',
    dueDate: '2024-01-10T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE010',
    refNumber: 'ADV-2024-00010',
    client: mockClients[0],
    product: mockProducts[0],
    applicantName: 'Vikram Patel',
    applicantPhone: '+91 98765 00010',
    applicantEmail: 'vikram.patel@email.com',
    address: 'Flat 502, Sky High Towers, Satellite, Ahmedabad, GJ 380015',
    status: CASE_STATUSES.QC_PENDING,
    priority: 'high',
    assignedTo: mockUsers[4],
    createdAt: '2026-05-18T10:00:00Z',
    updatedAt: '2026-05-19T12:00:00Z',
    dueDate: '2026-05-22T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE011',
    refNumber: 'ADV-2024-00011',
    client: mockClients[1],
    product: mockProducts[2],
    applicantName: 'Deepika Padukone',
    applicantPhone: '+91 98765 00011',
    applicantEmail: 'deepika@email.com',
    address: 'Plot 12, Juhu Scheme, Mumbai, MH 400049',
    status: CASE_STATUSES.ASSIGNED,
    priority: 'medium',
    assignedTo: mockUsers[5],
    createdAt: '2026-05-20T11:00:00Z',
    updatedAt: '2026-05-20T11:00:00Z',
    dueDate: '2026-05-25T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [],
    timeline: [],
  },
  {
    id: 'CASE012',
    refNumber: 'ADV-2024-00012',
    client: mockClients[2],
    product: mockProducts[4],
    applicantName: 'Aarav Mehta',
    applicantPhone: '+91 98765 00012',
    applicantEmail: 'aarav.mehta@email.com',
    address: '12, Residency Road, Bangalore, KA 560025',
    status: CASE_STATUSES.COMPLETED,
    priority: 'low',
    assignedTo: mockUsers[4],
    createdAt: '2026-05-15T09:00:00Z',
    updatedAt: '2026-05-17T15:00:00Z',
    dueDate: '2026-05-20T18:00:00Z',
    documents: [],
    images: [],
    qcLogs: [
      { action: 'Approved', comment: 'Salary slips and bank statements match income declaration', user: mockUsers[3], timestamp: '2026-05-17T15:00:00Z' }
    ],
    timeline: [],
  },
];

export const mockInvoices = [
  { id: 'INV001', number: 'INV-2024-001', client: mockClients[0], amount: 125000, status: 'paid', date: '2024-01-01', dueDate: '2024-01-15', paidDate: '2024-01-10', cases: 50 },
  { id: 'INV002', number: 'INV-2024-002', client: mockClients[1], amount: 98000, status: 'pending', date: '2024-01-05', dueDate: '2024-01-20', paidDate: null, cases: 40 },
  { id: 'INV003', number: 'INV-2024-003', client: mockClients[2], amount: 75600, status: 'overdue', date: '2023-12-20', dueDate: '2024-01-05', paidDate: null, cases: 35 },
  { id: 'INV004', number: 'INV-2024-004', client: mockClients[4], amount: 65400, status: 'paid', date: '2024-01-08', dueDate: '2024-01-22', paidDate: '2024-01-15', cases: 28 },
];

export const mockPayouts = [
  { id: 'PAY001', user: mockUsers[4], type: 'field_executive', amount: 15000, status: 'approved', date: '2024-01-15', cases: 30 },
  { id: 'PAY002', user: mockUsers[5], type: 'field_executive', amount: 12500, status: 'pending', date: '2024-01-16', cases: 25 },
  { id: 'PAY003', user: mockUsers[6], type: 'vendor', amount: 45000, status: 'approved', date: '2024-01-14', cases: 90 },
  { id: 'PAY004', user: mockUsers[8], type: 'business_partner', amount: 25000, status: 'pending', date: '2024-01-16', cases: 0, commission: '5%' },
];

export const mockPenalties = [
  { id: 'PEN001', user: mockUsers[4], reason: 'Late submission', amount: 500, status: 'approved', date: '2024-01-10', approvedBy: mockUsers[2] },
  { id: 'PEN002', user: mockUsers[5], reason: 'Incomplete verification', amount: 1000, status: 'pending', date: '2024-01-15', approvedBy: null },
  { id: 'PEN003', user: mockUsers[6], reason: 'Quality issues', amount: 2500, status: 'rejected', date: '2024-01-12', approvedBy: mockUsers[1] },
];

export const mockNotifications = [
  { id: 'NOT001', title: 'New Case Assigned', message: 'Case CASE005 has been assigned to you', type: 'info', read: false, timestamp: '2024-01-16T08:30:00Z', targetRole: 'field_executive' },
  { id: 'NOT002', title: 'QC Rejection', message: 'Case CASE004 has been rejected. Please revisit.', type: 'danger', read: false, timestamp: '2024-01-16T10:00:00Z', targetRole: 'field_executive' },
  { id: 'NOT003', title: 'Payment Processed', message: 'Your payout of Rs. 15,000 has been processed', type: 'success', read: true, timestamp: '2024-01-15T16:00:00Z', targetRole: 'field_executive' },
  { id: 'NOT004', title: 'New Client Added', message: 'HDFC Bank has been added as a new client', type: 'info', read: true, timestamp: '2024-01-14T12:00:00Z', targetRole: 'admin' },
];

export const mockActivityFeed = [
  { id: 'ACT001', action: 'Case Completed', description: 'Case ADV-2024-00003 completed by Vikram Singh', timestamp: '2024-01-16T14:30:00Z', user: mockUsers[4] },
  { id: 'ACT002', action: 'QC Approved', description: 'Case ADV-2024-00003 approved by Sneha Reddy', timestamp: '2024-01-16T14:00:00Z', user: mockUsers[3] },
  { id: 'ACT003', action: 'New Case', description: 'New case ADV-2024-00006 created for Kotak Mahindra', timestamp: '2024-01-16T11:00:00Z', user: mockUsers[0] },
  { id: 'ACT004', action: 'User Added', description: 'New field executive Ananya Gupta added', timestamp: '2024-01-16T09:00:00Z', user: mockUsers[1] },
  { id: 'ACT005', action: 'Invoice Generated', description: 'Invoice INV-2024-002 generated for ICICI Bank', timestamp: '2024-01-15T18:00:00Z', user: mockUsers[0] },
];

export const mockRates = [
  { id: 'RATE001', client: mockClients[0], product: mockProducts[0], clientRate: 300, vendorPayout: 180, fePayout: 150, extraKmRate: 5 },
  { id: 'RATE002', client: mockClients[0], product: mockProducts[1], clientRate: 400, vendorPayout: 250, fePayout: 200, extraKmRate: 5 },
  { id: 'RATE003', client: mockClients[1], product: mockProducts[2], clientRate: 250, vendorPayout: 150, fePayout: 120, extraKmRate: 4 },
  { id: 'RATE004', client: mockClients[2], product: mockProducts[0], clientRate: 280, vendorPayout: 170, fePayout: 140, extraKmRate: 5 },
  { id: 'RATE005', client: mockClients[4], product: mockProducts[5], clientRate: 600, vendorPayout: 380, fePayout: 300, extraKmRate: 6 },
];

export const mockFormTemplates = [
  {
    id: 'FORM001',
    name: 'Address Verification Form',
    client: mockClients[0],
    product: mockProducts[0],
    fields: [
      { id: 'f1', type: 'text', label: 'Applicant Name', required: true },
      { id: 'f2', type: 'text', label: 'Address', required: true },
      { id: 'f3', type: 'dropdown', label: 'Residence Type', options: ['Owned', 'Rented', 'Company Provided', 'PG'], required: true },
      { id: 'f4', type: 'checkbox', label: 'Address Confirmed', required: true },
      { id: 'f5', type: 'image', label: 'Property Photo', required: true, maxImages: 5 },
      { id: 'f6', type: 'text', label: 'Landmark', required: false },
      { id: 'f7', type: 'dropdown', label: 'Locality Type', options: ['Urban', 'Semi-Urban', 'Rural'], required: true },
    ],
  },
  {
    id: 'FORM002',
    name: 'Employment Verification Form',
    client: mockClients[1],
    product: mockProducts[1],
    fields: [
      { id: 'f1', type: 'text', label: 'Employee Name', required: true },
      { id: 'f2', type: 'text', label: 'Company Name', required: true },
      { id: 'f3', type: 'text', label: 'Designation', required: true },
      { id: 'f4', type: 'dropdown', label: 'Employment Type', options: ['Permanent', 'Contract', 'Temporary'], required: true },
      { id: 'f5', type: 'checkbox', label: 'Employment Verified', required: true },
      { id: 'f6', type: 'image', label: 'Office Photo', required: true, maxImages: 3 },
    ],
  },
];

export const dashboardStats = {
  totalCases: 1847,
  pendingCases: 234,
  completedCases: 1456,
  qcFailed: 87,
  revisitRequired: 70,
  todayCases: 45,
  monthlyRevenue: 2850000,
  monthlyPayouts: 1425000,
};

export const chartData = {
  caseTrends: [
    { month: 'Aug', cases: 1200, completed: 1100 },
    { month: 'Sep', cases: 1350, completed: 1280 },
    { month: 'Oct', cases: 1420, completed: 1350 },
    { month: 'Nov', cases: 1580, completed: 1490 },
    { month: 'Dec', cases: 1720, completed: 1620 },
    { month: 'Jan', cases: 1847, completed: 1456 },
  ],
  revenueVsPayouts: [
    { month: 'Aug', revenue: 2100000, payouts: 1050000 },
    { month: 'Sep', revenue: 2350000, payouts: 1175000 },
    { month: 'Oct', revenue: 2480000, payouts: 1240000 },
    { month: 'Nov', revenue: 2650000, payouts: 1325000 },
    { month: 'Dec', revenue: 2780000, payouts: 1390000 },
    { month: 'Jan', revenue: 2850000, payouts: 1425000 },
  ],
  casesByStatus: [
    { status: 'Completed', value: 1456, color: '#10b981' },
    { status: 'In Progress', value: 234, color: '#f59e0b' },
    { status: 'QC Pending', value: 87, color: '#3b82f6' },
    { status: 'Revisit', value: 70, color: '#ef4444' },
  ],
  casesByProduct: [
    { product: 'Address', value: 650 },
    { product: 'Employment', value: 420 },
    { product: 'KYC', value: 380 },
    { product: 'Document', value: 220 },
    { product: 'Income', value: 177 },
  ],
};

// --- PRODUCT & VERIFICATION MANAGEMENT SYSTEM NEW MOCK DATA ---

export const defaultProducts = [
  { id: 'DP001', name: 'Credit Card', code: 'CC', status: 'active' },
  { id: 'DP002', name: 'Cash Credit – Mudra Loan', code: 'CCML', status: 'active' },
  { id: 'DP003', name: 'Personal Loan', code: 'PL', status: 'active' },
  { id: 'DP004', name: 'Home Loan', code: 'HL', status: 'active' },
  { id: 'DP005', name: 'Car Loan', code: 'CL', status: 'active' },
  { id: 'DP006', name: 'Gold Loan', code: 'GL', status: 'active' },
  { id: 'DP007', name: 'Education Loan', code: 'EL', status: 'active' },
  { id: 'DP008', name: 'Commercial Vehicle Loan', code: 'CVL', status: 'active' },
  { id: 'DP009', name: 'Business Loan', code: 'BL', status: 'active' },
  { id: 'DP010', name: 'Document', code: 'DOC', status: 'active' },
  { id: 'DP011', name: 'Audits', code: 'AUD', status: 'active' },
  { id: 'DP012', name: 'Background Verification', code: 'BGV', status: 'active' },
  { id: 'DP013', name: 'Solar Loan Pre', code: 'SLPRE', status: 'active' },
  { id: 'DP014', name: 'Solar Loan Post', code: 'SLPOST', status: 'active' },
  { id: 'DP015', name: 'Digital Verification', code: 'DV', status: 'active' },
  { id: 'DP016', name: 'Collection', code: 'COLL', status: 'active' },
  { id: 'DP017', name: 'Other', code: 'OTH', status: 'active' },
];

export const defaultVerificationTypes = [
  { id: 'VT001', name: 'Residence Verification', status: 'active' },
  { id: 'VT002', name: 'Office Verification', status: 'active' },
  { id: 'VT003', name: 'Business Verification', status: 'active' },
  { id: 'VT004', name: 'Aadhaar Verification', status: 'active' },
  { id: 'VT005', name: 'PAN Verification', status: 'active' },
  { id: 'VT006', name: 'Salary Slip Verification', status: 'active' },
  { id: 'VT007', name: 'ITR Verification', status: 'active' },
  { id: 'VT008', name: 'Bank Statement Verification', status: 'active' },
  { id: 'VT009', name: 'Document Verification', status: 'active' },
  { id: 'VT010', name: 'Cheque/NACH/Document Pickup', status: 'active' },
  { id: 'VT011', name: 'Airtel Device Pickup', status: 'active' },
  { id: 'VT012', name: 'Employment Check', status: 'active' },
  { id: 'VT013', name: 'Reference Check', status: 'active' },
  { id: 'VT014', name: 'Site Verification', status: 'active' },
  { id: 'VT015', name: 'Vehicle Verification', status: 'active' },
  { id: 'VT016', name: 'Digital Residence Verification', status: 'active' },
  { id: 'VT017', name: 'Residence Verification Permanent', status: 'active' },
  { id: 'VT018', name: 'Residence Verification Current', status: 'active' },
  { id: 'VT019', name: 'PAN Card Delivery Status', status: 'active' },
  { id: 'VT020', name: 'Other', status: 'active' },
];

// Map dynamic verification types to Credit Card by default
export const defaultProductVerificationMappings = [
  { id: 'M001', productId: 'DP001', verificationTypeId: 'VT001' }, // Residence
  { id: 'M002', productId: 'DP001', verificationTypeId: 'VT002' }, // Office
  { id: 'M003', productId: 'DP001', verificationTypeId: 'VT003' }, // Business
  { id: 'M004', productId: 'DP001', verificationTypeId: 'VT012' }, // Employment Check
  { id: 'M005', productId: 'DP001', verificationTypeId: 'VT005' }, // PAN
  { id: 'M006', productId: 'DP001', verificationTypeId: 'VT004' }, // Aadhaar
  { id: 'M007', productId: 'DP001', verificationTypeId: 'VT016' }, // Digital Residence
  { id: 'M008', productId: 'DP001', verificationTypeId: 'VT013' }, // Reference Check
  { id: 'M009', productId: 'DP001', verificationTypeId: 'VT014' }, // Site Verification
];

// Questions for Residence Verification (VT001) Lead Creation
export const defaultLeadCreationQuestions = [
  { id: 'LC001', verificationTypeId: 'VT001', fieldLabel: 'Loan Amount', fieldType: 'number', required: true, sortOrder: 1 },
  { id: 'LC002', verificationTypeId: 'VT001', fieldLabel: 'Applicant Name', fieldType: 'text', required: true, sortOrder: 2 },
  { id: 'LC003', verificationTypeId: 'VT001', fieldLabel: 'Residence Address', fieldType: 'textarea', required: true, sortOrder: 3 },
  { id: 'LC004', verificationTypeId: 'VT001', fieldLabel: 'Contact Number', fieldType: 'text', required: true, sortOrder: 4 },
  { id: 'LC005', verificationTypeId: 'VT001', fieldLabel: 'Alternate Contact Number', fieldType: 'text', required: false, sortOrder: 5 },
  { id: 'LC006', verificationTypeId: 'VT001', fieldLabel: 'City', fieldType: 'text', required: true, sortOrder: 6 },
  { id: 'LC007', verificationTypeId: 'VT001', fieldLabel: 'Pincode', fieldType: 'number', required: true, sortOrder: 7 },
  { id: 'LC008', verificationTypeId: 'VT001', fieldLabel: 'State', fieldType: 'text', required: true, sortOrder: 8 },
  { id: 'LC009', verificationTypeId: 'VT001', fieldLabel: 'Additional Comment', fieldType: 'textarea', required: false, sortOrder: 9 },
];

// Verification Questions (VT001 - Positive Status)
export const defaultPositiveVerificationQuestions = [
  { id: 'VQ001', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Address Confirmed', fieldType: 'dropdown', required: true, optionsJson: '["Yes", "No"]', sortOrder: 1 },
  { id: 'VQ002', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Address Confirmed By', fieldType: 'dropdown', optionsJson: '["Self", "Family Member", "Neighbor", "Third Party"]', required: true, sortOrder: 2 },
  { id: 'VQ003', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Person Met Name', fieldType: 'text', required: true, sortOrder: 3 },
  { id: 'VQ004', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Relationship With Applicant', fieldType: 'dropdown', optionsJson: '["Self", "Spouse", "Parent", "Sibling", "Child", "Other"]', required: true, sortOrder: 4 },
  { id: 'VQ005', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Date Of Birth', fieldType: 'date', required: true, sortOrder: 5 },
  { id: 'VQ006', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Family Members', fieldType: 'number', required: true, sortOrder: 6 },
  { id: 'VQ007', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Earning Members', fieldType: 'number', required: true, sortOrder: 7 },
  { id: 'VQ008', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Dependent', fieldType: 'number', required: true, sortOrder: 8 },
  { id: 'VQ009', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Ownership Of Residence', fieldType: 'dropdown', optionsJson: '["Owned", "Rented", "Parent Owned", "Provided by Company"]', required: true, sortOrder: 9 },
  { id: 'VQ010', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Rent Amount', fieldType: 'number', required: false, sortOrder: 10 },
  { id: 'VQ011', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Address Type', fieldType: 'dropdown', optionsJson: '["Residential", "Commercial", "Semi-Residential"]', required: true, sortOrder: 11 },
  { id: 'VQ012', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Ease Of Location', fieldType: 'dropdown', optionsJson: '["Easy", "Moderate", "Difficult"]', required: true, sortOrder: 12 },
  { id: 'VQ013', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Exterior Condition', fieldType: 'dropdown', optionsJson: '["Good", "Average", "Poor"]', required: true, sortOrder: 13 },
  { id: 'VQ014', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Type Of Residence', fieldType: 'dropdown', optionsJson: '["Flat", "Independent House", "Chawl", "Bungalow"]', required: true, sortOrder: 14 },
  { id: 'VQ015', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Standard Of Living', fieldType: 'dropdown', optionsJson: '["High", "Medium", "Low"]', required: true, sortOrder: 15 },
  { id: 'VQ016', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Area In Sqft', fieldType: 'number', required: true, sortOrder: 16 },
  { id: 'VQ017', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Landmark', fieldType: 'text', required: true, sortOrder: 17 },
  { id: 'VQ018', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Field Remark', fieldType: 'textarea', required: true, sortOrder: 18 },
  { id: 'VQ019', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Document Provided', fieldType: 'dropdown', optionsJson: '["Electricity Bill", "Rent Agreement", "Aadhaar Card", "None"]', required: true, sortOrder: 19 },
  { id: 'VQ020', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Date Of Visit', fieldType: 'date', required: true, sortOrder: 20 },
  { id: 'VQ021', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Neighbour Name 1', fieldType: 'text', required: true, sortOrder: 21 },
  { id: 'VQ022', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Neighbour Name 2', fieldType: 'text', required: true, sortOrder: 22 },
  { id: 'VQ023', verificationTypeId: 'VT001', verificationStatus: 'positive', fieldLabel: 'Status', fieldType: 'dropdown', optionsJson: '["Positive Verified", "Partially Verified"]', required: true, sortOrder: 23 },
];

export const defaultPositiveRequiredImages = [
  { label: 'Person Met Image', required: true, geoTag: true },
  { label: 'Selfie With House', required: true, geoTag: true },
  { label: 'House Image 1', required: true, geoTag: true },
  { label: 'House Image 2', required: true, geoTag: true },
  { label: 'Address Proof', required: true, geoTag: false },
  { label: 'Landmark Image', required: true, geoTag: true },
  { label: 'Additional Image Optional', required: false, geoTag: false },
];

// Verification Questions (VT001 - Negative Status)
export const defaultNegativeVerificationQuestions = [
  { id: 'VQ_NEG001', verificationTypeId: 'VT001', verificationStatus: 'negative', fieldLabel: 'Detailed Reason For Negative', fieldType: 'textarea', required: true, sortOrder: 1 },
  { id: 'VQ_NEG002', verificationTypeId: 'VT001', verificationStatus: 'negative', fieldLabel: 'Status', fieldType: 'dropdown', optionsJson: '["Door Locked", "No Such Person", "Address Not Found", "Refused Information", "Applicant Shifted"]', required: true, sortOrder: 2 },
];

export const defaultNegativeRequiredImages = [
  { label: 'Location Image 1', required: true, geoTag: true },
  { label: 'Location Image 2', required: true, geoTag: true },
  { label: 'Location Image 3', required: false, geoTag: true },
  { label: 'Location Image 4', required: false, geoTag: true },
  { label: 'Location Image 5', required: false, geoTag: true },
  { label: 'Selfie With Landmark', required: true, geoTag: true },
];

// Add a few simulation leads for our Lead Verification Flow
export const mockLeadsForVerification = [
  {
    id: 'LEAD001',
    refNumber: 'LD-2026-00001',
    applicantName: 'Vikram Patel',
    applicantPhone: '+91 98989 89898',
    applicantEmail: 'vikram.patel@email.com',
    address: 'A-404, Shanti Heights, Satellite',
    pincode: '380015',
    city: 'Ahmedabad',
    state: 'Gujarat',
    priority: 'medium',
    client: 'ICICI Bank',
    status: 'assigned',
    assignDate: '2026-05-19',
    companyName: 'TCS Ltd',
    comments: 'Verify employee card and office seating desk.',
  }
];

// --- HIERARCHY ACCESS & MOBILEFORCE DETAILS UPDATE ---

// Additional mock users to showcase isolated downlines
export const mockAdditionalHierarchyUsers = [
  { id: 'USR012', name: 'Rajeev Malhotra', email: 'rajeev.m@adventures.com', role: 'supreme_manager', status: 'active', avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100', phone: '+91 98765 43221', joinDate: '2023-04-10' },
  { id: 'USR013', name: 'Vikrant Rao', email: 'vikrant.rao@adventures.com', role: 'manager', status: 'active', avatar: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=100', phone: '+91 98765 43222', joinDate: '2023-05-20' },
  { id: 'USR014', name: 'Suresh Raina', email: 'suresh.raina@adventures.com', role: 'field_executive', status: 'active', avatar: 'https://images.unsplash.com/photo-1489980508314-941910ded1f4?w=100', phone: '+91 98765 43223', joinDate: '2023-06-15' },
  { id: 'USR015', name: 'Karan Sharma', email: 'karan.sharma@vendorfe.com', role: 'vendor_fe', status: 'active', avatar: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=100', phone: '+91 98765 43224', joinDate: '2023-12-01' },
];

// Merge into the global users list
mockUsers.push(...mockAdditionalHierarchyUsers);

export const mockHierarchy = {
  // Supreme Manager Priya Sharma Downline Tree
  'USR002': {
    id: 'USR002',
    name: 'Priya Sharma',
    role: 'Supreme Manager',
    children: [
      {
        id: 'USR003',
        name: 'Amit Patel',
        role: 'Manager',
        children: [
          {
            id: 'USR004',
            name: 'Sneha Reddy',
            role: 'Quality Checker',
            children: [
              {
                id: 'USR007',
                name: 'Karan Mehta',
                role: 'Vendor',
                children: [
                  { id: 'USR005', name: 'Vikram Singh', role: 'Field Executive' }
                ]
              },
              {
                id: 'USR009',
                name: 'Rohit Verma',
                role: 'Business Partner',
                children: [
                  { id: 'USR006', name: 'Ananya Gupta', role: 'Field Executive' }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  // Isolated South Region Supreme Manager Rajeev Malhotra Downline Tree
  'USR012': {
    id: 'USR012',
    name: 'Rajeev Malhotra',
    role: 'Supreme Manager',
    children: [
      {
        id: 'USR013',
        name: 'Vikrant Rao',
        role: 'Manager',
        children: [
          { id: 'USR014', name: 'Suresh Raina', role: 'Field Executive' }
        ]
      }
    ]
  }
};

// Retrieve all user IDs residing strictly under a user's assigned downline (recursive)
export const getDownlineUserIds = (userId) => {
  const downline = [];
  const traverse = (node) => {
    if (!node) return;
    if (node.id !== userId) {
      downline.push(node.id);
    }
    if (node.children) {
      node.children.forEach(traverse);
    }
  };

  const root = mockHierarchy[userId];
  if (root) {
    traverse(root);
  } else {
    // If not a supreme manager, check if they are a child inside any tree and find their subtree
    const findAndTraverse = (nodes) => {
      for (const key in nodes) {
        let found = null;
        const search = (node) => {
          if (node.id === userId) {
            found = node;
            return;
          }
          if (node.children) {
            node.children.forEach(search);
          }
        };
        search(nodes[key]);
        if (found) {
          traverse(found);
          break;
        }
      }
    };
    findAndTraverse(mockHierarchy);
  }
  return downline;
};

// Enrich all mock cases with detailed MobileForce Q&A answers, watermarked images, Remarks, Map coordinates, positive status indicators
export const enrichMockCasesWithMobileForce = () => {
  return mockCases.map((c, index) => {
    // Set verificationType and status
    const isEven = index % 2 === 0;
    const client = c.client?.name || 'HDFC Bank';
    const executiveName = c.assignedTo?.name || 'Vikram Singh';
    const isCompleted = [CASE_STATUSES.COMPLETED, CASE_STATUSES.REPORT_SENT, CASE_STATUSES.QC_APPROVED].includes(c.status);
    
    return {
      ...c,
      verificationType: c.product?.name || 'Residence Verification',
      verificationStatus: isEven ? 'positive' : 'negative',
      decisionStatus: isEven ? 'positive' : (index % 3 === 0 ? 'revisit' : 'negative'),
      answers: isEven ? [
        { question: 'Address Confirmed', answer: 'Yes' },
        { question: 'Address Confirmed By', answer: 'Self Meet (Applicant)' },
        { question: 'Person Met Name', answer: c.applicantName },
        { question: 'Relationship With Applicant', answer: 'Self' },
        { question: 'Ownership Of Residence', answer: 'Owned (Family Owned)' },
        { question: 'Standard Of Living', answer: 'Medium - Premium' },
        { question: 'Ease Of Location', answer: 'Easy (Near main road)' },
        { question: 'Exterior Condition', answer: 'Good (Well maintained)' },
        { question: 'Landmark', answer: 'Near Metro Station Pillar 45' },
        { question: 'Neighbour Name 1', answer: 'Ramesh Trivedi' },
        { question: 'Neighbour Name 2', answer: 'Alok Saxena' },
        { question: 'Date Of Visit', answer: '2026-05-18' }
      ] : [
        { question: 'Address Confirmed', answer: 'No' },
        { question: 'Reason for Negative', answer: 'Door Locked continuously during multiple attempts' },
        { question: 'Status Found', answer: 'No Response/Locked' },
        { question: 'Neighbour Feedback', answer: 'Family went out of station since last 1 week' },
        { question: 'Landmark Verification', answer: 'Confirmed the building structure matches' },
        { question: 'Date Of Visit', answer: '2026-05-18' }
      ],
      verifiedImages: [
        {
          label: 'Applicant / Entrance Gate Photo',
          url: isEven ? 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=500' : 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=500',
          latitude: 23.0225 + (index * 0.001),
          longitude: 72.5714 - (index * 0.001),
          timestamp: '2026-05-18 11:23:45 AM',
          address: c.address
        },
        {
          label: 'House Exterior / Identity Proof Photo',
          url: isEven ? 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=500' : 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=500',
          latitude: 23.0226 + (index * 0.001),
          longitude: 72.5715 - (index * 0.001),
          timestamp: '2026-05-18 11:26:12 AM',
          address: c.address
        },
        {
          label: 'Landmark Photo',
          url: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=500',
          latitude: 23.0224 + (index * 0.001),
          longitude: 72.5713 - (index * 0.001),
          timestamp: '2026-05-18 11:28:01 AM',
          address: `Landmark close to ${c.address}`
        }
      ],
      mapCoords: {
        latitude: 23.0225 + (index * 0.001),
        longitude: 72.5714 - (index * 0.001)
      },
      remarks: {
        feRemark: isEven
          ? `The applicant ${c.applicantName} resides at the given location. Verified ownership via electricity bill. Highly positive.`
          : `Visited the premises multiple times. House was found locked. Neighbors confirmed they are out of town. Negative.`,
        qcRemark: isEven
          ? `All photos are clear. GPS address matches perfectly. Recommended for approval.`
          : `Re-visited logs confirmed. Neighbor signatures collected by executive. QC verification complete.`,
        finalRemark: isEven
          ? `Cleared and approved by Supreme Manager.`
          : `Declined due to door locked status.`
      }
    };
  });
};

export const mockEnrichedCases = enrichMockCasesWithMobileForce();

// Separate case to represent secondary region (Rajeev Malhotra hierarchy)
export const mockSouthRegionCase = {
  id: 'CASE009',
  refNumber: 'ADV-2026-99999',
  client: mockClients[0],
  product: mockProducts[0],
  applicantName: 'Karthik Raja',
  applicantPhone: '+91 99999 88888',
  applicantEmail: 'karthik.raja@email.com',
  address: 'No 45, Residency Road, Richmond Town, Bangalore, Karnataka 560025',
  status: CASE_STATUSES.IN_PROGRESS,
  priority: 'high',
  assignedTo: mockUsers.find(u => u.id === 'USR014'), // Suresh Raina
  createdAt: '2026-05-19T10:00:00Z',
  updatedAt: '2026-05-19T12:00:00Z',
  dueDate: '2026-05-22T18:00:00Z',
  documents: [],
  images: [],
  qcLogs: [],
  timeline: [],
  verificationType: 'Residence Verification',
  verificationStatus: 'positive',
  decisionStatus: 'positive',
  answers: [
    { question: 'Address Confirmed', answer: 'Yes' },
    { question: 'Date Of Visit', answer: '2026-05-19' }
  ],
  verifiedImages: [
    {
      label: 'Entrance Photo',
      url: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=500',
      latitude: 12.9611,
      longitude: 77.5956,
      timestamp: '2026-05-19 11:00:00 AM',
      address: 'No 45, Residency Road, Bangalore, KA 560025'
    }
  ],
  mapCoords: { latitude: 12.9611, longitude: 77.5956 },
  remarks: {
    feRemark: 'Resides at South Bangalore location.',
    qcRemark: 'Coordinates matches, approved.',
    finalRemark: 'Approved by South Supervisor.'
  }
};

// Add South Region case to our general cases list
mockCases.push(mockSouthRegionCase);
mockEnrichedCases.push({
  ...mockSouthRegionCase,
  answers: [
    { question: 'Address Confirmed', answer: 'Yes' },
    { question: 'Date Of Visit', answer: '2026-05-19' }
  ]
});

// Assign cases to the new Vendor FE user (Karan Sharma - USR015) for operational visibility
const vendorFeUserObj = mockUsers.find(u => u.id === 'USR015');
if (vendorFeUserObj) {
  const c5 = mockCases.find(c => c.id === 'CASE005');
  if (c5) {
    c5.assignedTo = vendorFeUserObj;
    c5.status = CASE_STATUSES.IN_PROGRESS;
  }
  const c5Enriched = mockEnrichedCases.find(c => c.id === 'CASE005');
  if (c5Enriched) {
    c5Enriched.assignedTo = vendorFeUserObj;
    c5Enriched.status = CASE_STATUSES.IN_PROGRESS;
  }

  const c6 = mockCases.find(c => c.id === 'CASE006');
  if (c6) {
    c6.assignedTo = vendorFeUserObj;
    c6.status = CASE_STATUSES.ASSIGNED;
  }
  const c6Enriched = mockEnrichedCases.find(c => c.id === 'CASE006');
  if (c6Enriched) {
    c6Enriched.assignedTo = vendorFeUserObj;
    c6Enriched.status = CASE_STATUSES.ASSIGNED;
  }

  const c3 = mockCases.find(c => c.id === 'CASE003');
  if (c3) {
    c3.assignedTo = vendorFeUserObj;
    c3.status = CASE_STATUSES.COMPLETED;
  }
  const c3Enriched = mockEnrichedCases.find(c => c.id === 'CASE003');
  if (c3Enriched) {
    c3Enriched.assignedTo = vendorFeUserObj;
    c3Enriched.status = CASE_STATUSES.COMPLETED;
  }

  const c7 = mockCases.find(c => c.id === 'CASE007');
  if (c7) {
    c7.assignedTo = vendorFeUserObj;
    c7.status = CASE_STATUSES.REVISIT;
  }
  const c7Enriched = mockEnrichedCases.find(c => c.id === 'CASE007');
  if (c7Enriched) {
    c7Enriched.assignedTo = vendorFeUserObj;
    c7Enriched.status = CASE_STATUSES.REVISIT;
  }
}

// Helper function to filter cases dynamically based on a user's role and hierarchy scope
export const getFilteredCasesForUser = (userId, userRole) => {
  // If Client, filter strictly by HDFC Bank (CLT001)
  if ([ROLES.client, 'client'].includes(userRole)) {
    return mockEnrichedCases.filter(c => c.client?.id === 'CLT001');
  }

  // If Admin, Universal QC or DEO, return everything
  if ([ROLES.admin, ROLES.universal_qc, 'admin'].includes(userRole)) {
    return mockEnrichedCases;
  }

  // If Supreme Manager or Manager, filter strictly by downline hierarchy
  if ([ROLES.supreme_manager, ROLES.manager, 'supreme_manager', 'manager'].includes(userRole)) {
    const downlineIds = getDownlineUserIds(userId);
    // Include their own cases and cases assigned to their downline personnel
    return mockEnrichedCases.filter(c => {
      if (!c.assignedTo) return false;
      return c.assignedTo.id === userId || downlineIds.includes(c.assignedTo.id);
    });
  }

  // If FE or Vendor, filter by their specific assignments
  return mockEnrichedCases.filter(c => c.assignedTo && c.assignedTo.id === userId);
};

export const mockAuditLogs = [
  // CASE001
  {
    id: 1,
    case_id: 'CASE001',
    action_type: 'Case Created',
    prev_user: null,
    new_user: 'Rajesh Kumar (Client)',
    role: 'client',
    date_time: '2026-05-15 10:30:00',
    ip_address: '192.168.1.10',
    remarks: 'Case imported via Excel sheet bulk upload.'
  },
  {
    id: 2,
    case_id: 'CASE001',
    action_type: 'Assigned',
    prev_user: null,
    new_user: 'Amit Patel (Manager)',
    role: 'manager',
    date_time: '2026-05-15 10:45:00',
    ip_address: '192.168.1.1',
    remarks: 'Case assigned to Regional Manager for verification routing.'
  },
  {
    id: 3,
    case_id: 'CASE001',
    action_type: 'Assigned',
    prev_user: 'Amit Patel',
    new_user: 'Karan Mehta (Vendor)',
    role: 'vendor',
    date_time: '2026-05-15 11:20:00',
    ip_address: '192.168.1.12',
    remarks: 'Assigned to South Region vendor agency.'
  },
  {
    id: 4,
    case_id: 'CASE001',
    action_type: 'Assigned',
    prev_user: 'Karan Mehta',
    new_user: 'Vikram Singh (Field Executive)',
    role: 'field_executive',
    date_time: '2026-05-15 11:35:00',
    ip_address: '192.168.2.14',
    remarks: 'Allocated to Field Executive for physical site check.'
  },
  {
    id: 5,
    case_id: 'CASE001',
    action_type: 'Verification Started',
    prev_user: null,
    new_user: 'Vikram Singh',
    role: 'field_executive',
    date_time: '2026-05-16 09:00:00',
    ip_address: '172.16.5.3',
    remarks: 'GPS coordinates verified, field executive reached target location.'
  },
  {
    id: 6,
    case_id: 'CASE001',
    action_type: 'Verification Submitted',
    prev_user: null,
    new_user: 'Vikram Singh',
    role: 'field_executive',
    date_time: '2026-05-16 14:15:00',
    ip_address: '172.16.5.3',
    remarks: 'Verification answers and watermarked images uploaded to portal.'
  },
  {
    id: 7,
    case_id: 'CASE001',
    action_type: 'QC Rejected',
    prev_user: null,
    new_user: 'Sneha Reddy (Quality Checker)',
    role: 'quality_checker',
    date_time: '2026-05-16 17:30:00',
    ip_address: '192.168.1.5',
    remarks: 'Address match validation failed. Requested revisit for clear gate photo.'
  },
  {
    id: 8,
    case_id: 'CASE001',
    action_type: 'Penalty Applied',
    prev_user: null,
    new_user: 'System Auto-Dialer',
    role: 'admin',
    date_time: '2026-05-16 17:35:00',
    ip_address: '127.0.0.1',
    remarks: 'Auto-applied penalty of ₹500 for delayed coordination check.'
  },
  {
    id: 9,
    case_id: 'CASE001',
    action_type: 'Penalty Waive Off Requested',
    prev_user: null,
    new_user: 'Vikram Singh',
    role: 'field_executive',
    date_time: '2026-05-17 10:00:00',
    ip_address: '172.16.5.4',
    remarks: 'Waiver request submitted. Reason: Technical GPS server issue.'
  },
  {
    id: 10,
    case_id: 'CASE001',
    action_type: 'Penalty Waive Off Approved',
    prev_user: null,
    new_user: 'Rajesh Kumar (Admin)',
    role: 'admin',
    date_time: '2026-05-17 12:00:00',
    ip_address: '192.168.1.1',
    remarks: 'Admin approved penalty waive-off request.'
  },
  {
    id: 11,
    case_id: 'CASE001',
    action_type: 'QC Approved',
    prev_user: null,
    new_user: 'Sneha Reddy',
    role: 'quality_checker',
    date_time: '2026-05-17 15:00:00',
    ip_address: '192.168.1.5',
    remarks: 'Revisit photo approved. Case marked as SLA passed.'
  },
  {
    id: 12,
    case_id: 'CASE001',
    action_type: 'Case Closed',
    prev_user: null,
    new_user: 'Rajesh Kumar (Admin)',
    role: 'admin',
    date_time: '2026-05-18 09:20:00',
    ip_address: '192.168.1.1',
    remarks: 'Final report successfully dispatched. Case closed.'
  },
  
  // CASE002
  {
    id: 13,
    case_id: 'CASE002',
    action_type: 'Case Created',
    prev_user: null,
    new_user: 'Neha Joshi (Client)',
    role: 'client',
    date_time: '2026-05-14 09:15:00',
    ip_address: '192.168.3.11',
    remarks: 'Case created via client portal API.'
  },
  {
    id: 14,
    case_id: 'CASE002',
    action_type: 'Assigned',
    prev_user: null,
    new_user: 'Amit Patel (Manager)',
    role: 'manager',
    date_time: '2026-05-14 10:00:00',
    ip_address: '192.168.1.1',
    remarks: 'Assigned to General Manager.'
  },
  {
    id: 15,
    case_id: 'CASE002',
    action_type: 'Assigned',
    prev_user: 'Amit Patel',
    new_user: 'Ananya Gupta (Field Executive)',
    role: 'field_executive',
    date_time: '2026-05-14 11:30:00',
    ip_address: '192.168.1.1',
    remarks: 'Assigned directly to Field Executive.'
  },
  {
    id: 16,
    case_id: 'CASE002',
    action_type: 'Verification Started',
    prev_user: null,
    new_user: 'Ananya Gupta',
    role: 'field_executive',
    date_time: '2026-05-15 08:30:00',
    ip_address: '172.16.9.1',
    remarks: 'First visit attempt made.'
  },
  {
    id: 17,
    case_id: 'CASE002',
    action_type: 'Draft Saved',
    prev_user: null,
    new_user: 'Ananya Gupta',
    role: 'field_executive',
    date_time: '2026-05-15 12:00:00',
    ip_address: '172.16.9.1',
    remarks: 'Saved draft answers: applicant not at home.'
  },
  {
    id: 18,
    case_id: 'CASE002',
    action_type: 'Verification Submitted',
    prev_user: null,
    new_user: 'Ananya Gupta',
    role: 'field_executive',
    date_time: '2026-05-16 16:45:00',
    ip_address: '172.16.9.1',
    remarks: 'Submitted verification report as Door Locked.'
  },
  {
    id: 19,
    case_id: 'CASE002',
    action_type: 'QC Review',
    prev_user: null,
    new_user: 'Sneha Reddy (Quality Checker)',
    role: 'quality_checker',
    date_time: '2026-05-16 17:00:00',
    ip_address: '192.168.1.5',
    remarks: 'Awaiting final coordinator audit.'
  }
];

export const getFilteredAuditLogsForCase = (caseId, userId, userRole) => {
  const caseItem = mockEnrichedCases.find(c => c.id === caseId) || mockCases.find(c => c.id === caseId);
  if (!caseItem) return [];

  const logs = mockAuditLogs.filter(log => log.case_id === caseId);

  // Admin / Supreme Manager / Quality Checker / Universal QC can see all logs
  if (['admin', 'supreme_manager', 'quality_checker', 'universal_qc'].includes(userRole)) {
    return logs;
  }

  // Client role (HDFC Bank only)
  if (userRole === 'client') {
    if (caseItem.client?.id === 'CLT001' || caseItem.client_id === 'CLT001') {
      return logs;
    }
    return [];
  }

  // Manager: cases assigned to manager or their downline hierarchy
  if (userRole === 'manager') {
    const downlineIds = getDownlineUserIds(userId);
    const assigneeId = caseItem.assignedTo?.id || caseItem.assignedTo_id;
    if (assigneeId === userId || downlineIds.includes(assigneeId)) {
      return logs;
    }
    return [];
  }

  // Vendor: cases assigned to vendor or their downline FEs
  if (userRole === 'vendor') {
    const downlineIds = getDownlineUserIds(userId);
    const assigneeId = caseItem.assignedTo?.id || caseItem.assignedTo_id;
    if (assigneeId === userId || downlineIds.includes(assigneeId)) {
      return logs;
    }
    return [];
  }

  return [];
};

